<ng-container *ngIf="showCookiePolicyBanner">
    <div class="row px-5 py-3 no-gutters subBlockContainer" id="cookiePolicyBanner">
        <div class="col-10 px-4 text-center">
            <!-- <p>By using the website, you are agreeing to our <a href="https://www.dickerdata.com.au/privacy-policy" target="_blank">Privacy
                    Policy</a>, <a  href="https://www.dickerdata.com.au/terms-and-conditions" target="_blank">Terms &amp; Conditions</a> and the use of
                cookies in accordance with our <a  href="https://www.dickerdata.com.au/terms-and-conditions" target="_blank">Cookie Policy</a>.
            </p> -->
            <p class="pl-5 my-0">This website uses cookies. Cookies are used to personalise content, analyse
                traffic, provide social media
                features and maintain session information. Please review our <a
                    href="https://www.dickerdata.com.au/privacy-policy" target="_blank"> Privacy Policy </a> for
                more
                details. By closing
                this banner or by clicking a link or continuing to browse otherwise, you consent to our cookies.
            </p>
        </div>
        <div class="col-2 text-left">
            <button class="button button-red" (click)="acceptSiteCookiePolicy()">ACCEPT</button>
        </div>
    </div>
</ng-container>

<div id="emergencyBanner" *ngIf="isDisplay" class="row">
    <div class="col-3"></div>
    <div class="col-6">
        <mat-accordion>
            <mat-expansion-panel class="expansion-panel" *ngFor="let item of displayPromotionList">
                <mat-expansion-panel-header class="row">
                    <mat-panel-title class="panel-description col-3">
                        <img *ngIf="item?.brand=='warning'" class="emergencyBannerIcon"
                            src="../images/new_ui/emergency1-warning-white.png" alt="icon1">
                        <img *ngIf="item?.brand=='prohibited'" class="emergencyBannerIcon"
                            src="../images/new_ui/emergency2-prohibited-white.png" alt="icon1">
                        <img *ngIf="item?.brand=='information'" class="emergencyBannerIcon"
                            src="../images/new_ui/emergency3-information-white.png" alt="icon1">
                    </mat-panel-title>
                    <mat-panel-description class="panel-description col-7">
                        {{item?.title}}
                    </mat-panel-description>
                    <!-- <mat-panel-description class="panel-title col-3">
                            </mat-panel-description> -->
                </mat-expansion-panel-header>
                <div class="emergencyDetails row">
                    <div class="col-3 emergencyDetailsIcon">
                        <img *ngIf="item?.brand=='warning'" class="emergencyBannerIconBig"
                            src="../images/new_ui/emergency1-warning-white.png" alt="icon1">
                        <img *ngIf="item?.brand=='prohibited'" class="emergencyBannerIconBig"
                            src="../images/new_ui/emergency2-prohibited-white.png" alt="icon1">
                        <img *ngIf="item?.brand =='information'" class="emergencyBannerIconBig"
                            src="../images/new_ui/emergency3-information-white.png" alt="icon1">
                    </div>
                    <div class="col-8" style="margin-left: 15px">
                        {{item?.description}}
                    </div>
                    <!-- <div class="col-4"></div> -->
                </div>
                <!-- <ul>
                            <li *ngFor="let product of promotionDeleteList">
                                {{product.description}}
                            </li>
                        </ul> -->
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <div class="col-3"></div>
</div>

<ng-container *ngIf="isSiteBannerDisplay">
    <div class="row" id="siteBanner" [style.background]="siteBannerColor">
        <div class="col-12 text-center">{{siteBannerText}}</div>
    </div>
</ng-container>


<div class="navigationbar">
    <nav class="navbar navbar-toggleable-md navbar-light bg-faded">
        <a id="main-logo" class="navbar-brand" [routerLink]="['/home']">
            <img src="../images/logo-invert.png" width="auto" height="31" alt="">
        </a>
        <div class="gloSearchInputGroup" id="globalSearch" *ngIf="showSearchBar()" (ngInit)="addAnimation()">
            <div class="searchIcon" title="Search products (global)" (click)="search(searchField)">
                <img src="../images/site-icons/search-red.svg">
            </div>
            <!-- <ng-template #tipContent><div>Start your search here.</div></ng-template> -->
            <input class="form-control mr-sm-2 searchbar searchInput" type="text" placement="bottom"
                placeholder="Search keywords" onfocus="this.placeholder=''" onblur="this.placeholder='Search keywords'"
                [(ngModel)]="searchField" (keyup.enter)="search(searchField)">
            <!-- <i class="material-icons global-search-cross" (click)="clearSearchBox()">close</i> -->
            <div class="global-search-cross" (click)="clearSearchBox()">
                <img src="../images/site-icons/cross-red.svg">
            </div>
        </div>
    </nav>
    <div style="width: 5%;"></div>
    <div class="navbtns">
        <div class="image-container" id="btnHelp" style="width:53px" (click)="onChangeToggle(2, $event)"
            [ngClass]="{'activeIcon':toggleOption==2}">
            <div class="nav_user">
                <img src="../images/site-icons/helpIcon.svg">
            </div>
        </div>

        <!-- <div class="image-container" id="btnHelp" style="width:53px" (click)="onChangeToggle(7, $event)"
            matTooltip="{{ myLocation }}"
            [matTooltipPosition]="'below'"
            matTooltipClass="line-broken-tooltip"
            [ngClass]="{'activeIcon':toggleOption==7}">
            <div class="nav_user whiten">
                <img src="../images/site-icons/black-red-icon/delivery-docket.svg">
            </div>
        </div> -->

        <div [class.highlightSection]="tourStep=='step2'" [attr.disabled]="tourStep=='step2'"
            [ngbPopover]="popContentCart" triggers="manual" #popoverCart="ngbPopover" placement="bottom"
            class="image-container align-right" id="cart-icon-parent-div" (click)="onChangeToggle(3, $event)"
            [ngClass]="{'activeIcon':toggleOption==3}">
            <span class="personal-info" id="cartIcon-child-div">
                <p>{{cartName}}</p>
                <p id="topCartTotalValue" [class]="blink?'blink_me':''">TOTAL: {{totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</p>
            </span>
            <span class="user-icon">
                <img class="icon-wrapper" src="../images/site-icons/cart.svg">
            </span>
        </div>

        <ng-container *ngIf="currentUserModel?.source!='SAP'">

            <div [class.highlightSection]="tourStep=='step1'" [attr.disabled]="tourStep=='step1'"
                [ngbPopover]="popContent" triggers="manual" #popover="ngbPopover" placement="bottom"
                class="image-container align-right user" id="user-image-div" (click)="onChangeToggle(6, $event)"
                [ngClass]="{'activeIcon':toggleOption==6 && !aliased, 'user-image-div-aliased':aliased  }">
                <span class="personal-info" id="personal-account-wrapper">
                    <p>{{currentUserModel?.email}}</p>
                    <p>{{currentUserModel?.companyName}} {{currentUserModel?.accountId}}</p>
                </span>
                <span class="user-icon">
                    <img class="icon-wrapper" src="../images/site-icons/userIcon.svg">
                </span>
            </div>
            <ng-template #popContent>
                <p><b>Step 1</b> – Update your Profile Information and Preferences</p>
                <button class="button button-red button-mid" (click)="nextTourStep()">Next Step</button>
            </ng-template>

        </ng-container>


        <ng-container *ngIf="currentUserModel?.source==='SAP'">

            <div class="text-center p-3" id="back-meridian-div" (click)="closeCurrentTab()">
                <p>BACK TO MERIDIAN</p>
            </div>

        </ng-container>

<!-- 
        <div class="image-container" id="btnHelp" style="width:53px;" *ngIf="currentUserModel?.isStaffAccount"
            [ngClass]="{'activeIcon':toggleOption==8}" (click)="onChangeToggle(8, $event)">
            <div class="nav_user">
                <img src="../images/site-icons/sale-icon-white.svg">
            </div>
        </div> -->



        <ng-template #popContentCart>
            <p><b>Step 2</b> – List of carts to Select and Swap between Carts</p>
            <button class="button button-red button-mid" (click)="previousTourStepOne()">Previous Step</button>
            <button class="button button-red button-mid" (click)="nextTourStepTwo()">Next Step</button>
        </ng-template>
    </div>
    <div id="resetToggle" (click)="resetToggle()" style="display: none"></div>
    <!-- <modal-popup [modalTitle]="modalDetails.title" [modalContent]="modalDetails.content"></modal-popup> -->
</div>
<ng-template #entry></ng-template>
<ng-template #chatbot></ng-template>
